import React from 'react'
import { useLanguage } from '../../../../../LanguageProvider';
import { useToaster } from '../../../../../ToasterProvider';

export default function SocialHiveInviteChannel({ selectedChannel }) {
    const { getTranslation } = useLanguage();
    const { toastSuccess } = useToaster();

    const url = `lodos.sh/channel/${selectedChannel.channelURI}`;
    // const url = `localhost:3000/${selectedChannel.channelURI}`;

    const handleCopy = () => {
        navigator.clipboard.writeText("https://" + url)
            .then(() => {
                toastSuccess(getTranslation("copiedToClipboard"));
            })
            .catch(err => {
                console.error('Kopyalama başarısız:', err);
            });
    };

    return (
        <div className="sh-settings-main">
            <div className="sh-settings-content" style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column' }}>
                <span style={{ color: 'var(--colloborators-table-row-font-color)' }}> {url}</span>
                <div className="add-channel-modal-actions">
                    <button
                        onClick={handleCopy}
                        className="add-channel-modal-button create"
                    >
                        {getTranslation("copy")}
                    </button>
                </div>
            </div>
        </div>
    )
}
